import {useEffect, RefObject} from "react";

interface UseLoadMoreSentinelParams {
    sentinelRef: RefObject<Element>;
    onLoadMore: () => void;
    rootMargin?: string;
    threshold?: number;
}

export const useLoadMoreSentinel = ({
    sentinelRef,
    onLoadMore,
    rootMargin = "300px 0px",
    threshold = 0.1,
}: UseLoadMoreSentinelParams) => {
    useEffect(() => {
        const sentinel = sentinelRef.current;
        if (!sentinel) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (!entry?.isIntersecting) return;
                onLoadMore();
            },
            {
                root: null,
                rootMargin,
                threshold,
            }
        );

        observer.observe(sentinel);

        return () => {
            observer.disconnect();
        };
    }, [onLoadMore, rootMargin, sentinelRef, threshold]);
};
